import { useGLTF } from '@react-three/drei';

export const CloudBig = () => {
  const gltf = useGLTF('models/decoration/nature/cloud_big.gltf');

  return <primitive object={gltf.scene} position={[0, -1, 6.5]} scale={[1, 1, 1]} castShadow />;
};
